import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bmwicon-视角锁定",
  "use": "icon-bmwicon-视角锁定-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-bmwicon-视角锁定\"><path d=\"M20,8.33C12.68,8.33,7,12.77,0,20c6,6.15,11.07,11.67,20,11.67s15.48-7,20-11.5C35.38,14.82,28.82,8.4,20,8.4m0,20a8.17,8.17,0,0,1-8-8.33h0a8.18,8.18,0,0,1,8-8.34h0a8.17,8.17,0,0,1,8,8.33h0a8.17,8.17,0,0,1-8,8.33h0\" /><path d=\"M20,17.07a3,3,0,0,1,.68-1.9,3.86,3.86,0,0,0-.68,0,4.85,4.85,0,1,0,4.66,5,1.09,1.09,0,0,0,0-.18c0-.21,0-.43,0-.64A2.84,2.84,0,0,1,20,17.1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol